<template>
	<main>
		<TopBottomLayout>
			<h6>Hot 랭킹</h6>
			<ResponsiveLayout v-if="getBannerMulti?.hotranking && getBannerMulti?.hotranking?.length > 0">
				<SubSwiperSlide :data="getBannerMulti?.hotranking ?? []" />
			</ResponsiveLayout>
			<div v-for="(item, index) in hotrankingCategoryData" :key="index" class="ly_col-48 c_responsive">
				<HotRankItemLayout v-for="(key, keyIndex) in Object.keys(item)" :key="keyIndex">
					<h3>{{ key }}</h3>
					<HotRankMainGridList :data="item[key]" @upload:item="onClickCard" />
				</HotRankItemLayout>
			</div>
		</TopBottomLayout>
	</main>
</template>

<script setup lang="ts">
// core
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useGetBannerMultiApi } from '@/api/banner';
// api
import { useGetHotrankingCategoryApi } from '@/api/hotRanking';
import HotRankItemLayout from '@/components/hotRank/HotRankItemLayout.vue';
import HotRankMainGridList from '@/components/hotRank/HotRankMainGridList.vue';
import ResponsiveLayout from '@/components/layout/main/ResponsiveLayout.vue';
// component
import TopBottomLayout from '@/components/layout/main/TopBottomLayout.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';

// -----variable-----
const router = useRouter();

// -----api-----
const { data: getBannerMulti } = useGetBannerMultiApi({ type: 'hotranking' });
const { data: hotrankingCategoryData } = useGetHotrankingCategoryApi(
	computed(() => ({ hot_ranking_category_pk: '', enabled: true }))
);
// -----function-----
const onClickCard = async (pk: number, categoryPk: number) => {
	router.push(`/hot-ranking-detail/usa/${pk}/${categoryPk}`);
};
</script>

<style scoped lang="scss">
main {
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
